import script from "./ShareViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareViewer.vue?vue&type=script&setup=true&lang=js"

import "./ShareViewer.vue?vue&type=style&index=0&id=56945902&lang=css"

const __exports__ = script;

export default __exports__